// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QwgJtGeCP64FIF {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 40px;
}
.LmlsF8EEx_Pi_p {
  padding: 16px 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": `QwgJtGeCP64FIF`,
	"container": `LmlsF8EEx_Pi_p`
};
export default ___CSS_LOADER_EXPORT___;
